export const SESSIONS_REFETCH_INTERVAL = 30 * 1000; // 30 seconds
// Moved to `@heidi/session/contracts` with the D1 family — it's baked into
// the v2 infinite-sessions cache key, so it's part of the key contract.
export { SESSIONS_PAGE_SIZE } from '@heidi/session/contracts';

// React Query key for the flag-gated session list (see useQuerySessionsList).
// Re-exported from `@heidi/session/contracts`, where the key contracts now
// live (OpenSpec `monorepo-session-data-core` task C1); this line keeps the
// existing importers resolving until task Z1's codemod re-points them.
export { GET_SESSIONS_LIST } from '@heidi/session/contracts';

/**
 * Retry configuration for session list queries.
 * Uses exponential backoff to handle transient failures
 * (e.g. stale auth tokens after desktop app update, network warmup).
 */
export const SESSIONS_QUERY_RETRY = 3;
export const SESSIONS_QUERY_RETRY_DELAY = (attemptIndex: number) =>
  Math.min(1000 * 2 ** attemptIndex, 10_000);

// Single-declared on `@heidi/session/contracts`. Re-exported so logout and the
// remaining app readers keep one string.
export {
  CACHED_VISIBLE_SCOPES_STORAGE_KEY,
  DESKTOP_SESSIONS_LIST_CACHE_KEY,
  SESSION_LIST_SCOPE_STORAGE_KEY,
} from '@heidi/session/contracts';

/** localStorage keys for the session list's persisted view state: the active
 *  scope tab, and a per-scope cache of sort + filters (each scope keeps its
 *  own). Kept across logout so they survive re-login.
 *
 *  `SESSION_LIST_SCOPE_STORAGE_KEY` backs `sessionListScopeAtom`, which is shared
 *  with the legacy list (the legacy toolbar resets it to `me` — see that atom's
 *  doc); `SESSION_LIST_VIEW_BY_SCOPE_STORAGE_KEY` is new-list-only and caches
 *  sort, date range, status and urgency filters plus `clinicianIdsByScope`
 *  (clinician IDs). The patient-profile filter is deliberately NOT cached, so no
 *  patient identifier is ever persisted here. Both keys are user-scoped
 *  (suffixed with `user_ref_id` via `createUserScopedStorageAtom`). */
export const SESSION_LIST_VIEW_BY_SCOPE_STORAGE_KEY = 'heidi.sessionListViewByScope';
